module.exports = __webpack_public_path__ + "static/media/hair12.5cac160e.png";